import React from 'react';
import styles from './AffiliateVideo.module.css';

function AffiliateVideo({ videoUrl }) {
    return (
        <section className={styles.section}>
            <div className={styles.inner}>
                <div className={styles.label}>A message from our founder</div>
                <h2 className={styles.h2}>Why we're inviting you to share this</h2>
                <p className={styles.description}>
                    Paul, founder of TB2 Health, on why GLP-1 access matters now — and why the people you care about may be waiting to hear about it from you.
                </p>
                <div className={styles.player}>
                    <iframe
                        className={styles.iframe}
                        src={videoUrl}
                        title="Paul Moss - Why We're Inviting You"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        </section>
    );
}

export default AffiliateVideo;
